import script from "./FooterMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterMenu.vue?vue&type=script&setup=true&lang=js"

import "./FooterMenu.vue?vue&type=style&index=0&id=c5ee59de&lang=css"

const __exports__ = script;

export default __exports__